/* eslint-disable */
export default {
  cancel: '취소',
  pmiChangeConfirmed: '변경',
  pmiChangeConfirmTitle: '개인 모임 설정을 변경하시겠습니까?',
  pmiChangeConfirmContext:
    '이 설정을 변경하면 이미 예약한 항목을 포함하여 개인 모임 ID나 이름을 사용하는 모든 모임에 영향을 줍니다.',
  updatePassword: '비밀번호 업데이트',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"pmiChangeConfirmed"@#@ @source: @#@"Change"@#@
// @key: @#@"pmiChangeConfirmTitle"@#@ @source: @#@"Change Personal Meeting settings?"@#@
// @key: @#@"pmiChangeConfirmContext"@#@ @source: @#@"Changing these settings will affect all meetings that use your personal meeting ID or name, including those you've already scheduled"@#@
// @key: @#@"updatePassword"@#@ @source: @#@"Update password"@#@
